// extracted by mini-css-extract-plugin
export default {"missionVisionValues":"MissionVisionValues_missionVisionValues__nTfCi","section":"MissionVisionValues_section__GTLa5"};